import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const Heart = createSvgIcon(
  () => (
    <path d="M37.5745 0.0595739C28.0674 -0.774656 24.1265 7.42398 24.0019 7.68815C23.8724 7.42398 19.9363 -0.774656 10.4245 0.0595739C0.754471 0.903074 -5.73697 12.3228 7.38016 30.0316C20.061 47.1565 23.7622 47.9629 23.9923 48H24.0019H24.0067C24.2368 47.9629 27.9428 47.1565 40.6236 30.0316C53.7359 12.3228 47.2445 0.903074 37.5745 0.0595739Z" />
  ),
  '0 0 48 48'
);
